import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/common/Navbar';
import LandingPage from './components/landing/LandingPage';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import Dashboard from './components/dashboard/Dashboard';
import ResumeBuilder from './components/builder/ResumeBuilder';
import CoverLetterBuilder from './components/builder/CoverLetterBuilder';
import ProtectedRoute from './components/ProtectedRoute';
import AuthProvider from './contexts/AuthContext';
import { FirebaseProvider } from './contexts/FirebaseContext';

const App = () => {
  return (
    <FirebaseProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black">
            <Navbar />
            <Toaster 
              position="top-right"
              toastOptions={{
                style: {
                  background: '#1F2937',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.1)',
                },
              }}
            />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/resume-builder"
                element={
                  <ProtectedRoute>
                    <ResumeBuilder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cover-letter-builder"
                element={
                  <ProtectedRoute>
                    <CoverLetterBuilder />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </FirebaseProvider>
  );
};

export default App;
